import { render, staticRenderFns } from "./ContactsTable.container.vue?vue&type=template&id=74c063ca&scoped=true&"
import script from "./ContactsTable.container.vue?vue&type=script&lang=js&"
export * from "./ContactsTable.container.vue?vue&type=script&lang=js&"
import style0 from "./ContactsTable.container.vue?vue&type=style&index=0&id=74c063ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c063ca",
  null
  
)

export default component.exports